import { Component } from '@angular/core';

/**
 * Component
 */
@Component({
    selector: 'app-ref-data',
    templateUrl: './ref-data.component.html',
    styleUrls: ['./ref-data.component.css'],
    standalone: false
})
export class RefDataComponent { }
